import { IClaimTrackingState } from './interfaces/claim-tracking-state'

export default class ClaimTrackingState implements IClaimTrackingState {
  public termsAndServicesAccepted = false
  public jobId = ''
  public trackingId = ''
  public isUserVerifiedSuccess = false
  public token = ''
}
